var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchieveGoalsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    viewBox: "0 0 45 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.714 35.9252L35.1979 18.8898C34.8487 18.2646 33.9475 18.2702 33.6067 18.9011L29.971 25.6826C29.7569 26.0909 29.1768 26.0966 28.9543 25.691L22.9613 14.9386C22.6121 14.3303 21.7363 14.3303 21.3871 14.9386L14.2366 27.5835C14.0113 27.9806 13.4368 27.9722 13.2228 27.5695L10.1925 21.8215C9.84329 21.2104 8.96463 21.2104 8.61541 21.8215L0.5666 35.9252C0.501827 36.0407 0.583498 36.1815 0.715861 36.1815H44.5647C44.6971 36.1815 44.7788 36.0407 44.714 35.9252Z",
    fill: "#3C3F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.68 1.90225V12.1815C21.68 12.4632 21.9081 12.6913 22.1897 12.6913H22.2545C22.5361 12.6913 22.7643 12.4632 22.7643 12.1815V7.11511C23.0938 7.02499 23.9865 6.79406 24.6399 6.76026C25.5946 6.71239 26.2226 7.29816 27.8081 7.39673C28.929 7.46714 29.6105 6.97148 29.9119 6.67578C30.033 6.55749 30.0977 6.39978 30.0977 6.23363C30.1062 5.43945 30.1259 2.84287 30.1062 1.76144C30.1006 1.54459 29.8696 1.40377 29.6669 1.49953C29.2106 1.71356 28.4052 1.99518 27.3322 1.99518C26.1972 1.99518 25.3721 1.43194 24.2907 1.38406C23.7443 1.35871 23.3275 1.51642 23.0515 1.67695C23.1557 1.52487 23.2148 1.339 23.2148 1.14186C23.2148 0.61241 22.7868 0.184341 22.2573 0.184341C21.7279 0.184341 21.2998 0.61241 21.2998 1.14186C21.2998 1.45447 21.4519 1.73046 21.6828 1.90506L21.68 1.90225Z",
    fill: "#3C3F43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.1924,
    height: 36,
    fill: "white",
    transform: "translate(0.543945 0.181519)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieveGoalsIcon);
export default __webpack_public_path__ + "static/media/achieve-goals-icon.ff5b86836480385ea1b0fa8b7f9cc164.svg";
export { ForwardRef as ReactComponent };